import { Scale, FileText, CheckCircle, Award, BookOpen } from "lucide-react";

// Le aree dei corsi sono etichette LIBERE, scelte da chi crea il corso: non sono più
// un elenco chiuso. L'elenco effettivo emerge dai corsi esistenti (endpoint backend
// /courses/areas e /public/catalog/areas). Qui restano solo le icone "note" per le
// aree storiche, con ripiego su un'icona generica per qualunque etichetta nuova.

// Match case-insensitive: chiavi normalizzate (minuscolo, trim) → icona.
const KNOWN_AREA_ICONS = [
  { keys: ["gare d'appalto", "gare appalto", "gare_appalto"], icon: Scale },
  { keys: ["offerte tecniche", "offerte_tecniche"], icon: FileText },
  { keys: ["sistemi iso", "iso"], icon: CheckCircle },
  { keys: ["attestazione soa", "soa"], icon: Award },
];

const _norm = (area) => (area || "").trim().toLowerCase();

// Icona associata a un'etichetta area (BookOpen per le aree non note).
export function areaIcon(area) {
  const key = _norm(area);
  for (const entry of KNOWN_AREA_ICONS) {
    if (entry.keys.includes(key)) return entry.icon;
  }
  return BookOpen;
}

// Etichetta visualizzabile: l'area È già l'etichetta; qui solo trim + ripiego.
export function areaLabel(area) {
  return (area || "").trim() || "—";
}

export { BookOpen as DEFAULT_AREA_ICON };
